import React, {useState, useEffect} from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
// @material-ui/icons
import { Email } from "@material-ui/icons";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function Faq(props) {
  const socialinfos = useSelector(state => state.socialinfos);
  const [dataInfos, setInfos] = useState({});

  useEffect(()=>{
    if(socialinfos.infos){
      setInfos(socialinfos.infos);
    }
  },[socialinfos.infos]);

  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container}>
            <br/>
            <h2 className={classes.title}>Dúvidas Frequentes</h2>
            <h4 className={classes.title}>O objetivo do Tac é facilitar a vida de seus usuários. Por isso, reunimos aqui dúvidas mais frequentes sobre o aplicativo, serviços ou cadastro.</h4>
            <br/>
            <h5 className={classes.title}>O download do aplicativo é gratuito? Para quais sistemas ele está disponível?</h5>
            <p className={classes.description}>Não há qualquer cobrança para o usuário instalar o aplicativo em seu celular. Ele está disponível para IOS e Android.</p>
            <br/>
            <h5 className={classes.title}>Tem disponibilidade na minha região?</h5>
            <p className={classes.description}>Para consultar a disponibilidade basta baixar nosso app e fazer seu cadastro. Se houver o disponibilidade o próprio aplicativo mostrará a informação na tela inicial.</p>
            <br/>
            <h5 className={classes.title}>Quem pode utilizar o aplicativo?</h5>
            <p className={classes.description}>Qualquer usuário, maior de 16 anos, mediante cadastro no próprio aplicativo.</p>
            <br/>
            <h5 className={classes.title}>Como faço para ser motorista?</h5>
            <p className={classes.description}>Basta ser maior de idade e cumprir os requisitos necessários para a validação de seu cadastro. Clique na opção do menu Motoristas para saber mais detalhes.</p>
            <br/>
            <h5 className={classes.title}>Se acontecer um acidente, quem se responsabiliza?</h5>
            <p className={classes.description}>No procedimento de cadastro do veículo no aplicativo, o motorista deve apresentar documento de contratação de cobertura para acidentes pessoais de passageiros (APP) de R$ 50 mil por pessoa. Esse documento é obrigatório.</p>
            <br/>
            <h5 className={classes.title}>Quais verificações são submetidas aos motoristas?</h5>
            <p className={classes.description}>Todo motorista tem sua carteira de habilitação verificada, documentos do veículo, antecedentes criminais, Seguro APP e além das validações dos dados ainda passam por constante treinamentos.</p>
            <br/>
            <br/>
            <h4 className={classes.title}>Não encontrou sua dúvida aqui? Entre em contato conosco, através dos nossos canais de atendimento!</h4>
            <h5 className={classes.description}>Sempre que necessitar de qualquer ajuda, quiser expor uma crítica construtiva ou fazer um elogio, o Tac vai estar disponível pra você!</h5>
            <h5 className={classes.description}>Contate-nos via ligação telefônica pelos números: (65) 99348-2157</h5>
            <div style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: "center"}}>
              <h5 className={classes.description}>Ou entre em contato via WhatsApp através do botão a seguir:  </h5>      
              <a href={`https://api.whatsapp.com/send?phone=${dataInfos.wpp_phone}&text=Olá Tac, necessito de atendimento!`} 
                 target="_blank">
                 <img   src="https://images.tcdn.com.br/static_inst/integracao/imagens/whatsapp.png" />
              </a>
            </div>
            <br/>
        </div>

      </div>

      <Footer />
    </div>
  );
}
